// import React from "react";
// import "./PGEcomTwoHome.scss";
import BusinessThreeAboutUs from "../../../business/businessThree/businessThreeComponents/BusinessThreeAboutUs";
import BusinessThreePartners from "../../../business/businessThree/businessThreeComponents/BusinessThreePartners";
import BusinessThreeFaq from "../../../business/businessThree/businessThreeComponents/BusinessThreeFaq";
import BusinessThreeWhyUs from "../../../business/businessThree/businessThreeComponents/BusinessThreeWhyUs";
import BusinessThreeProduct2 from "../../../business/businessThree/businessThreeComponents/BusinessThreeProduct2";
import BusinessThreeServices from "../../../business/businessThree/businessThreeComponents/BusinessThreeServices";
import BusinessThreeProduct from "../../../business/businessThree/businessThreeComponents/BusinessThreeProduct";
import BusinessThreeTestimonials from "../../../business/businessThree/businessThreeComponents/BusinessThreeTestimonials";
import BusinessThreeNewsAndBlogs from "../../../business/businessThree/businessThreeComponents/BusinessThreeNewsAndBlogs";
import BusinessThreeDownloadApp from "../../../business/businessThree/businessThreeComponents/BusinessThreeDownloadApp";
import BusinessThreeTeam from "../../../business/businessThree/businessThreeComponents/BusinessThreeTeam";
import { useDocument } from "../../../../firebase-files/hooks/useDocument";

// IMPORT BANNERS
import BusinessOneBanner from "../../../business/businessOne/businessOneComponents/BusinessOneBanner";
import BusinessThreeBanners from "../../../business/businessThree/businessThreeComponents/BusinessThreeBanners";
import HomeHeroBanners from "../../../../default-components/HomeHeroBanners";
import CorporateTwoBanner from "../../../corporate/corporateTwo/corporateTwoComponents/CorporateTwoBanner/CorporateTwoBanner";
import BlackberryProducts from "../../../blackberrys/bbComponents/BlackberryProducts";
import BlackberryCategory from "../../../blackberrys/bbComponents/BlackberryCategory";
import BlackberryBlogs from "../../../blackberrys/bbComponents/BlackberryBlogs";
import BlackberryShowcase from "../../../blackberrys/bbComponents/BlackberryShowcase";
// import CorporateOneBanner from "../../../corporate/corporateOne/corporateOneComponent/CorporateOneBanner";

const PGEcomTwoHome = () => {
  // BANNERS DOCUMENT
  const { document: dbBannersDocuments, error: dbBannersError } = useDocument(
    "settings",
    "banners"
  );

  // ACTIVE TEMPLATE DOCUMENT
  const { document: dbActiveTemplateDocuments, error: dbActiveTemplateError } =
    useDocument("settings", "templates");

  let activeTemplate =
    dbActiveTemplateDocuments && dbActiveTemplateDocuments.activeTemplate;

  // Mapping activeBanner values to components
  const bannerComponents = {
    HomeHeroBanners: HomeHeroBanners,
    BusinessOneBanner: BusinessOneBanner,
    BusinessThreeBanners: BusinessThreeBanners,
    // CorporateOneBanner:CorporateOneBanner,
    CorporateTwoBanner: CorporateTwoBanner,
  };

  return (
    <div>
      {dbBannersDocuments &&
        dbBannersDocuments.banners.map((banner, index) => {
          if (banner.templateName === activeTemplate) {
            const BannerComponent = bannerComponents[banner.activeBanner];
            return (
              <div key={index}>
                {BannerComponent && (
                  <BannerComponent
                    category="Banner"
                    pageName="home"
                    section="homeherobanners"
                    addMoreVideosButton={false}
                    addMoreTextContentButton={false}
                  />
                )}
              </div>
            );
          } else {
            return null;
          }
        })}

      <BusinessThreeAboutUs />
      {/* <div className="large_margin_div"></div> */}
      <BlackberryProducts />
      <BusinessThreeProduct2 />
      {/* <BusinessThreeServices /> */}
      <BlackberryCategory />
      <div className="large_margin_div"></div>
      <BusinessThreeProduct />
      <BlackberryBlogs />
      {/* <BusinessThreeTestimonials /> */}
      {/* <BusinessThreeFaq /> */}
      {/* <BusinessThreeWhyUs /> */}
      <BusinessThreeDownloadApp />
      {/* <BusinessThreeNewsAndBlogs /> */}
      <BlackberryShowcase />
      <BusinessThreeTeam />
      <BusinessThreePartners />

      {/* <div className="large_margin_div"></div> */}
    </div>
  );
};

export default PGEcomTwoHome;
